
import mixpanel from 'mixpanel-browser';
mixpanel.init('99d47f4fb5ced47a6215514853c1ea9a');

let env_check = true;

let actions = {
  identify: (id) => {
    if (env_check) mixpanel.identify(id);
  },
  alias: (id) => {
    if (env_check) mixpanel.alias(id);
  },
  track: (name, props) => {
    if (env_check) mixpanel.track(name, props);
  },
  people: {
    set: (props) => {
      if (env_check) mixpanel.people.set(props);
    },
  },
};

export let Mixpanel = actions;


// WEBPACK FOOTER //
// ./src/components/Mixpanel.js